export const getExchangeOrderId = state => state.returnExchange.exchangeOrderId;
export const getExchangeItemId = state => state.returnExchange.exchangeItemId;
